import React, { useEffect } from 'react';
import { useProgramOfStudies } from '@/hooks/useProgramOfStudies';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { ListQuestions } from './ListQuestions';
import { ContentQuestion } from './ContentQuestion';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';

export const UpdatePublicQuestions = () => {
  const navigate = useNavigate();
  const { selectedTaxonomy } = useProgramOfStudies();

  useEffect(() => {
    if (!selectedTaxonomy) {
      navigate('/ementa/banco-de-questoes');
    }
  }, []);

  if (!selectedTaxonomy) {
    return null;
  }

  return (
    <Dashboard>
      <Sidebar />

      <DashboardContent
        viewMode="create"
        className="md:!px-0 md:!py-0"
      >
        <div className="new-questions">
          <ListQuestions />

          <ContentQuestion />
        </div>
      </DashboardContent>
    </Dashboard>
  );
};
